import React, { useState, useEffect } from 'react';

const CustomerSlider = () => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(4);
  
  // Sample partner data
  const partners = [
    { src: "/assets/images/bluewod.webp", alt:"bluewood", label: "bluewood" },
    { src: "/assets/images/excel.jpeg", alt:"Excel", label: "Excel" },
    { src: "/assets/images/stas.webp", alt:"Stass", label: "Stass" },
    { src: "/assets/images/stag.webp", alt:"stag", label: "stag" },
    { src: "/assets/images/uni.jpeg", alt:"Universal", label: "Universal" },
  ];


  // Adjust visible count based on screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setVisibleCount(1);
      } else if (window.innerWidth < 1024) {
        setVisibleCount(2);
      } else {
        setVisibleCount(4);
      }
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === partners.length - visibleCount ? 0 : prevIndex + 1
      );
    }, 3000);
    
    return () => clearInterval(interval);
  }, [partners.length, visibleCount]);
  
  // Function to get visible partners
  const visiblePartners = () => {
    const visibleItems = [];
    for (let i = 0; i < visibleCount; i++) {
      const index = (currentIndex + i) % partners.length;
      visibleItems.push(partners[index]);
    }
    return visibleItems;
  };

  return (
    <div className="w-fulls py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8 text-sky-600">
          Our Valuable Customers
        </h2>
        <div className="relative overflow-hidden">
          <div className="flex items-center justify-center space-x-16">
            {visiblePartners().map((partner, index) => (
              <div key={index} className="flex flex-col items-center transition-all duration-500 ease-in-out">
                <div className="h-32 w-48 flex items-center justify-center mb-2 bg-gray-50 p-2 rounded">
                  <img
                    src={partner.src}
                    alt={partner.alt}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <span className="text-sm text-gray-600">{partner.label}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-center mt-6">
            {Array.from({ length: partners.length - visibleCount + 1 }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 w-2 mx-1 rounded-full ${
                  index === currentIndex ? 'bg-blue-500' : 'bg-gray-300'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerSlider;
